export default defineNuxtPlugin(async ({ vueApp }) => {
  const config = useRuntimeConfig()
  if (!config.public.sentryDisabled) {
    return
  }

  // dynamic import することで、バンドルサイズを軽減する
  const sentry = await import('@sentry/vue')
  const router = useRouter()

  sentry.init({
    enabled: !config.public.sentryDisabled,
    app: vueApp,
    dsn: config.public.sentryDsn,
    integrations: [sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    ignoreErrors: [
      // /Cannot read properties of null \(reading 'subTree'\)/,
      // /Failed to fetch/,
      // /Unable to preload CSS/,
      // /Failed to fetch dynamically imported module/,
      // /Importing a module script failed./,
    ],
  })
})
